// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { ApplicationLauncherListItem } from "../../../components/ApplicationLauncher";
import { DraftLauncherMenu } from "../../Draft";
import { FavoriteLauncherMenu } from "../../Favorite";
import { ModuleLauncherMenu } from "../../Module";
import { ModuleDataPrefetch } from "../../Module/components/ModuleDataPrefetch";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DomainLauncherListItem = props => {
  const {
    identifiant,
    libelle,
    icone,
    code,
    adresse
  } = props;
  return /*#__PURE__*/_jsx(ModuleDataPrefetch, {
    domain: {
      identifiant
    },
    "data-sentry-element": "ModuleDataPrefetch",
    "data-sentry-component": "DomainLauncherListItem",
    "data-sentry-source-file": "DomainLauncherListItem.tsx",
    children: /*#__PURE__*/_jsxs(ApplicationLauncherListItem, {
      libelle: libelle,
      name: `domaine.${_.snakeCase(libelle)}`,
      code: code,
      icon: icone,
      path: adresse,
      "data-sentry-element": "ApplicationLauncherListItem",
      "data-sentry-source-file": "DomainLauncherListItem.tsx",
      children: [/*#__PURE__*/_jsx(ModuleLauncherMenu, {
        domain: {
          identifiant
        },
        "data-sentry-element": "ModuleLauncherMenu",
        "data-sentry-source-file": "DomainLauncherListItem.tsx"
      }, "module"), /*#__PURE__*/_jsx(FavoriteLauncherMenu, {
        domain: {
          identifiant
        },
        "data-sentry-element": "FavoriteLauncherMenu",
        "data-sentry-source-file": "DomainLauncherListItem.tsx"
      }, "favorite"), /*#__PURE__*/_jsx(DraftLauncherMenu, {
        domain: {
          identifiant
        },
        "data-sentry-element": "DraftLauncherMenu",
        "data-sentry-source-file": "DomainLauncherListItem.tsx"
      }, "draft")]
    })
  });
};